module.exports = __webpack_public_path__ + "img/consultation_c.a310ec4a.png";